import { useCallback, useState } from "react";

/**
 * Estado de los campos simples del formulario. Separa el "que vale cada
 * campo" del "como se pinta": la validacion vive en model/solicitud.js y solo
 * entrega aqui el resultado via setErrores.
 */
export const useCamposFormulario = (iniciales, dependientes = {}) => {
  const [valores, setValores] = useState(iniciales);
  const [errores, setErrores] = useState({});

  // `dependientes` indica que campos se vacian cuando cambia otro, por
  // ejemplo el salon cuando cambia el bloque: { id_bloque: ["id_salon"] }.
  const onChange = ({ target: { name, value } }) => {
    const vaciar = (dependientes[name] ?? []).reduce(
      (acumulado, campo) => ({ ...acumulado, [campo]: iniciales[campo] }),
      {},
    );
    setValores((previos) => ({ ...previos, [name]: value, ...vaciar }));
    // Al corregir un campo desaparece su error, sin tocar los demas.
    setErrores(({ [name]: _resuelto, ...resto }) => resto);
  };

  const reiniciar = useCallback(() => {
    setValores(iniciales);
    setErrores({});
  }, [iniciales]);

  return { valores, errores, setErrores, onChange, reiniciar };
};
